// import css from "./popUp.module.css";
// import React from "react";

// const ChouseBook = React.forwardRef(({ onClick }, ref) => {
//   return (
//     <div className={css.mainPopWrapChose} ref={ref} onClick={onClick}>
//       <p className={css.mainPopP}>
//         Ми ті, хто створює книгу з ідеї, з першоелемента, як Малевич: від
//         чорного квадрата до великого барвистого світу, яким цікаво й корисно
//         мандрувати. Ми прагнемо долучати майстрів до створення кожного видання.
//         За допомогою пера й пензля вони вкладають у дитячу книгу свій цінний
//         досвід, який захоплює і допомагає дітям стати на власний шлях майстра.
//         Настав час майстрів!
//       </p>
//     </div>
//   );
// });
// export default ChouseBook;

import css from "./popUp.module.css";
import React from "react";
import { db } from "../../firebase"; // скоригуй імпорт під свій шлях
import { doc, onSnapshot } from "firebase/firestore";

const DOC_ID = "we_help_choose_book"; // фіксований ID для цього попапа

const ChouseBook = React.forwardRef(({ onClick, className }, ref) => {
  const [html, setHtml] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsub = onSnapshot(doc(db, "popups", DOC_ID), (snap) => {
      setLoading(false);
      if (!snap.exists()) {
        setHtml(""); // нічого не знайдено — порожньо
        return;
      }
      const d = snap.data();
      // контент зберігаємо як HTML з ReactQuill
      setHtml(d?.contentHtml || "");
    });

    return () => unsub();
  }, []);

  return (
    <div
      className={`${css.mainPopWrapChose} ${className || ""}`}
      ref={ref}
      onClick={onClick}
    >
      <div
        className={`${css.mainPopP} `} // Ubuntu для тексту
        dangerouslySetInnerHTML={{ __html: loading ? "…" : html }}
      />
    </div>
  );
});

export default ChouseBook;
